import React from 'react';
import { Menu, Bell } from 'lucide-react';
import { Logo } from '../Logo';

export function MobileNavbar() {
  return (
    <div className="bg-[#1A1D23] border-b border-[#2A2D35] px-4 py-3 fixed top-0 left-0 right-0 z-50">
      <div className="flex items-center justify-between">
        <button className="p-2 text-gray-400">
          <Menu className="w-6 h-6" />
        </button>
        <div className="flex-1 flex justify-center">
          <Logo className="h-8" />
        </div>
        <button className="p-2 text-gray-400">
          <Bell className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
}